<template>
    <base-spinner :open="isloading"></base-spinner>

    <base-dialog :newClass="'smartDialog'" :title="null" @close="closeSmartPageDialog" :open="smartPageUrl != ''">
        <template #default>
            <iframe :src="smartPageUrl"></iframe>
        </template>

        <template #actions>
            <span></span>
        </template>
    </base-dialog>

    <div class="products-view__list products-list products-list--grid--4" data-layout="table" data-with-features="false" v-if="unique_desc.length > 0">
        <div class="products-list__head">
            <div class="products-list__column products-list__column--image">Image</div>
            <div class="products-list__column products-list__column--qty">QTY</div>
            <div class="products-list__column products-list__column--product">Product</div>
            <div class="products-list__column products-list__column--information">Notes</div>
            <div class="products-list__column products-list__column--information">Information</div>
            <div class="products-list__column products-list__column--availability">Availability</div>
            <div class="products-list__column products-list__column--price">Price</div>
        </div>

        <div v-for="(unique, i) in unique_desc" :key="i">
            <div class="products-list__subheader products-list__subheader-text" v-if="unique.products.length > 0">
                <font class="products-list__subheader-text">{{unique.desc}}</font>
            </div>
            <div class="products-list__content">
                <results-product-item 
                    v-for="(product, indx) in group_products(unique.products)"
                    :key="product.ID"
                    :index='indx'
                    :product="product"
                    :source-page="'SearchResults'"
                    :searchBy="searchBy"
                    @open-smart-page-dialog="openSmartPageDialog"
                    @open-related-type="openRelatedTypes"
                    :productValid="(product.IMISVALID === 'N') ? false : true"
                    >
                </results-product-item>
            </div>
        </div>

        <related-part-types 
            ref="relatedPartType"
            @selected_type="selected_type">
        </related-part-types>

        <related-items ref="relatedItems"
            @open-smart-page="openSmartPageDialog"
            @open-related-type="openRelatedTypes">
        </related-items>
    </div>

    <div v-if="isloading == false && unique_desc.length == 0">
        <h4>There are no results for the selected {{ catclass }} search. <br><p></p>Please click the <i>New {{ catclass }} Product Search</i> button above if you would like to search another category or search for a specific part or OE number.</h4>
    </div>

</template>

<script>
import CategoryProductItem from './CategoryProductItem.vue';
import RelatedPartTypes from './RelatedPartTypes.vue';
import RelatedItems from './RelatedItems.vue';
import axiosvl from "../../../axios/axios-vl.js";
import * as GCONST from "../../../constants.js";
import { mapGetters } from 'vuex';

export default {
    components : {
        "results-product-item": CategoryProductItem,
        RelatedPartTypes,
        RelatedItems
    },
    props : {
        perPage : {
            type: Number,
            required: true,
        },
        currentPage: {
            type: Number,
            required: true,
        },
        filter_price: {
            type: String,
        },
        filter_availability: {
            type: String,
        },
        keyword: {
            type: String,
        },
        search_type: {
            type: String,
        }
    },
    emits: [
        'total_showing',
        'total_items'
    ],
    data() {
        return {
            parts : [],
            parts_desc: [],
            unique_desc: [],
            partslen: 0,
            page : 1,
            isloading: false,
            pages: [],

            smartPageUrl: '',

            selectedgroups: null,
            selectedcategories: null,
            storeCatalog: null,
            searchBy: 'WHI',

            relatedProduct: {},
            showRelated: false,
            has_alternative: 'N'
        }
    },

    computed: {
        ...mapGetters([
            'storeCatalog',
            'storefrontAttributes'
        ]),
        ...mapGetters("vehicle", [
            "selectedyear",
        ]),
        ...mapGetters('api', [
            "catclass",
        ]),
        displayedParts (unique) {
            console.log(unique);
            return [];
            // const paginated_parts = this.paginate(this.parts);
            // return paginated_parts;
        },
        selected_cat_getter() {
            return this.$store.getters['vehicle/selectedcategories'];
        },
    },
    watch: {
        parts () {
            this.setPages();
        },

        selected_cat_getter() {
            // console.log('change vehicles selected');
            this.searchParts();
        },

        selectedyear(newVal) {  
            console.log('newVal = ' + newVal);  
            // this.unique_desc = [];
            // setTimeout(() => {
            //     this.searchParts();    
            // }, 1000);
        },

        keyword() {
            // reset the value of the list
            this.parts = [];
            this.unique_desc = [];
            this.searchPLItems();
        }
    },
    methods: {
        clearList() {
            this.parts = [];
            this.unique_desc = [];
        },

        group_products(products){
            let nProd = [];
            if(this.filter_price == 'HighToLow'){
                products.sort((a,b) => (a.extended_price < b.extended_price) ? 1 : ((b.extended_price < a.extended_price) ? -1 : 0));
            }else{
                products.sort((a,b) => (a.extended_price > b.extended_price) ? 1 : ((b.extended_price > a.extended_price) ? -1 : 0));
            }

            if(this.filter_availability == 'InStock'){
                nProd = products.filter(p => p.stockquantity > 0);
            }else{
                nProd = products;
            }
            
            return nProd;
        },

        searchParts() {
            this.parts = [];
            this.isloading = true;
            let params;
            const vehicle_parts_uri = this.$store.getters['api/vehicle_partsM_uri'];
            // console.log(vehicle_parts_uri);
            // const vehicle_parts_uri = this.$store.getters['api/vehicle_parts_uri'];
            // const catpn = (this.storeCatalog.toUpperCase() == 'WHI') ? '003' : '002';
            const catpn = this.$store.getters['storeConfigID'];
            if (this.storeCatalog.toUpperCase() == 'WHI') {
                params = {
                    "webroutine": {
                        "context": {
                            "session-key-method": "hidden"
                        },
                        "fields": {
                            "EHCUST": { "value": this.$store.getters.customer },
                            "CATPN": { "value": catpn },
                            "QYEAR": { "value": this.$store.getters['vehicle/selectedyear'] },
                            "QMAKE": { "value": this.$store.getters['vehicle/selectedmake'].selectedmake },
                            "QMODEL": { "value": this.$store.getters['vehicle/selectedmodel'].selectedmodel },
                            "QCARCD": { "value": this.$store.getters['vehicle/selectedengine'].selectedengine },
                            // "QGROUP": { "value": this.$store.getters['vehicle/selectedgroups'][0] },
                            // "QTYPE": { "value": this.$store.getters['vehicle/selectedcategories'][0] }
                        },
                        "lists": {
                            "CQUSD": {
                                "header": [
                                    {"name": "QCQUIX"},
                                    {"name": "QCQUID"},
                                    {"name": "QCQUTX"},
                                    {"name": "QCQUTY"},
                                    {"name": "QCQUAN"},
                                    {"name": "QCQUGR"},
                                    {"name": "QCQUUK"},
                                    {"name": "QCQUAT"},
                                    {"name": "QCQUAR"},
                                    {"name": "QCQUAI"}
                                ],
                                "entries": [
                                    this.$store.getters['vehicle/selectedquestions']
                                ]
                            },
                            "TYPESI": {
                                "header": [
                                    {"name": "QTYPE"},
                                    {"name": "QGROUP"}
                                ],
                                "entries": this.$store.getters['vehicle/selectedcategories'],
                            }
                        }     
                    }
                };
            }else{
                // console.log(this.$store.getters['vehicle/selectedgroups']);
                // console.log(this.$store.getters['vehicle/selectedcategories']);
                params = {
                    "webroutine": {
                        "context": {
                            "session-key-method": "hidden"
                        },
                        "fields": {
                            "EHCUST": { "value": this.$store.getters.customer },
                            "CATPN": { "value": catpn },
                            "QYEAR": { "value": this.$store.getters['vehicle/selectedyear'] },
                            "QMKDSC": { "value": this.$store.getters['vehicle/selectedmake'].selectedmake },
                            "QMODSC": { "value": this.$store.getters['vehicle/selectedmodel'].selectedmodel },
                        },
                        "lists": {
                            "TYPESI": {
                                "header": [
                                    {"name": "QTYPE"},
                                    {"name": "QGROUP"}
                                ],
                                "entries": this.$store.getters['vehicle/selectedcategories']
                            }
                        }     
                    }
                };
            }

            axiosvl.post(vehicle_parts_uri, params)
            .then((response) => {
                const fields = response.data.webroutine.fields;
                const lists = response.data.webroutine.lists;
                const ETXLIST = lists.ETXLIST.entries;
                // console.log(response.data.webroutine.lists.PARTS.entries);
                if (fields.RESULTCOD.value === 'OK') {
                    // this.smartPageUrl = fields.TOPIMAGE.value;
                    if(this.smartPageUrl != ''){
                        this.$emit('open-smart', fields.TOPIMAGE.value);
                    }else{
                        this.$emit('no-smart');
                    }

                    this.parts_desc = ETXLIST;

                    for (const key in response.data.webroutine.lists.PARTS.entries) {
                        const obj = response.data.webroutine.lists.PARTS.entries[key];
                        // if(obj.IMISVALID == 'N'){
                        //     continue;
                        // }
                        this.parts.push({
                            manufacturer: obj.QMFR,
                            manufacturerdesc: obj.QMFDSC,
                            sku: obj.QITEMNUM,
                            description: obj.QITDSC.toUpperCase(),
                            QLIST: obj.QLIST,
                            QCORE: obj.QCORE,
                            extended_price: obj.QSELL,
                            // stockquantity: obj.QOHAND,
                            stockquantity: (this.$store.getters.customerIndicator == 'B') ? obj.QOHAND : obj.TOTOH,
                            availability: obj.QOSTK,
                            list_price: obj.QLISTN,
                            core_charge: obj.QCOREN,
                            QTDESC: obj.QTDESC,
                            QSCORE: obj.QSCORE,
                            QSCOREN: obj.QSCOREN,
                            EKSIZE: obj.EKSIZE,
                            QSIZE: obj.QSIZE,  
                            QITEMSZ: obj.QITEMSZ,
                            CUFLAG: obj.CUFLAG,  
                            QLISTNC: obj.QLISTNC,
                            QITSEQ: obj.QITSEQ,  
                            QITTXT: obj.QITTXT,
                            use_description: obj.QITUSE,                                
                            quantity_per_car: obj.QITPCQ,   
                            years: obj.QIPYRS,   
                            QICSEQ: obj.QICSEQ,   
                            QIGSEQ: obj.QIGSEQ,   
                            QIGDSC: obj.QIGDSC,
                            image: (obj.QITTMB) ? obj.QITTMB : obj.EPIMG,
                            QIMTAG: obj.QIMTAG,
                            QICON: obj.QICON,
                            catalog_part_number: obj.QICPN,
                            CLTYPE: obj.CLTYPE,
                            DEDESC: obj.DEDESC,
                            MCNAME: obj.MCNAME,
                            smartpage_url: obj.QITURL,
                            TOTOH: obj.TOTOH,
                            PARTN: obj.PARTN,
                            SHOWMTP: obj.SHOWMTP,
                            QITIMG: obj.QITIMG,
                            QITTMB: obj.QITTMB,
                            QTYPEC: obj.QTYPEC,
                            QMFRCD: obj.QMFRCD,
                            QITEMC: obj.QITEMC,
                            txt_list: this.parts_desc.filter(i => i.ETXITM == obj.QITEMNUM),

                            // partslink 
                            OE_number: (this.storeCatalog.toUpperCase() == 'PARTSLINK') ? obj.QICPN : '',
                            yr_range: (this.storeCatalog.toUpperCase() == 'PARTSLINK') ? obj.QIPYRS : '',
                            IMISVALID: obj.IMISVALID,
                            HASRELI: obj.HASRELI,
                        });
                    }

                    // update the OE Number from the parent item number
                    this.parts.forEach(p => {
                        if (p.CLTYPE == 'SUBSTITUTE'){
                            const parentItem = this.parts.find(par => par.QITEMSZ == p.QITEMSZ.slice(0, -1));
                            p.OE_number = parentItem.OE_number;
                        }
                    })

                    this.partslen = response.data.webroutine.lists.PARTS.entries.length;
                    // console.log(this.parts);
                    const unique_desc = [...new Set(this.parts.map(item => item.description))];
                    // console.log(unique_desc);
                    unique_desc.forEach(u => {
                        this.unique_desc.push({
                            desc : u,
                            products: this.parts.filter(p => p.description == u)
                        });
                    });

                    // console.log(this.unique_desc);

                    this.$emit('total_items', this.partslen);
                }
                this.isloading = false;
            })
            .catch((error) => {
                console.log("error - " + error);
                this.isloading = false;
            });
        },

        setPages () {
            this.pages = [];
            let numberOfPages = Math.ceil(this.parts.length / this.perPage);
            for (let index = 1; index <= numberOfPages; index++) {
                this.pages.push(index);
            }
        },

        paginate (parts) {
            let page = this.currentPage;
            let perPage = this.perPage;
            let from = (page * perPage) - perPage;
            let to = (page * perPage);

            const sliced = parts.slice(from, to);
            this.$emit('total_showing', sliced.length);

            return sliced;
        },
        closeSmartPageDialog() {
            this.smartPageUrl = '';
        },
        openSmartPageDialog(url) {
            this.smartPageUrl = url;
            // this.$emit('open-smart', url);
        },

        openRelatedTypes(product) {
            console.log(product);

            this.relatedProduct = product;
            // this.showRelated;
            if(this.storeCatalog == 'WHI'){
                this.$refs.relatedPartType.getRelatedTypes(product);
            }

            if(this.storeCatalog == 'PARTSLINK'){
                // this.$refs.relatedPartType.getPartRelated(product);
                this.$refs.relatedItems.getPartRelated(product);
            }
            
        },

        selected_type(type) {
            this.$refs.relatedItems.getRelatedItems(this.relatedProduct, type);
        },

        searchPLItems() {
            this.parts = [];
            this.isloading = true;
            let params;
            const pl_itemsearch_uri = this.$store.getters['api/pl_itemsearch_uri'];
            const catpn = this.$store.getters['storeConfigID'];

            params = {
                "webroutine": {
                    "context": {
                        "session-key-method": "hidden"
                    },
                    "fields": {
                        "EHCUST": { "value": this.$store.getters.customer },
                        "CATPN": { "value": catpn },
                        "SRCITM": { "value": this.keyword },
                    }
                }
            };

            axiosvl.post(pl_itemsearch_uri, params)
            .then((response) => {
                const fields = response.data.webroutine.fields;
                const lists = response.data.webroutine.lists;
                const ETXLIST = lists.ETXLIST.entries;
                // console.log(response.data.webroutine.lists.PARTS.entries);
                if (fields.RESULTCOD.value === 'OK') {

                    this.parts_desc = ETXLIST;

                    for (const key in response.data.webroutine.lists.PARTS.entries) {
                        const obj = response.data.webroutine.lists.PARTS.entries[key];
                        this.parts.push({
                            manufacturer: obj.QMFR,
                            manufacturerdesc: obj.QMFDSC,
                            sku: obj.QITEMNUM,
                            description: obj.QITDSC,
                            QLIST: obj.QLIST,
                            QCORE: obj.QCORE,
                            extended_price: obj.QSELL,
                            // stockquantity: obj.QOHAND,
                            stockquantity: (this.$store.getters.customerIndicator == 'B') ? obj.QOHAND : obj.TOTOH,
                            availability: obj.QOSTK,
                            list_price: obj.QLISTN,
                            core_charge: obj.QCOREN,
                            QTDESC: obj.QTDESC,
                            QSCORE: obj.QSCORE,
                            QSCOREN: obj.QSCOREN,
                            EKSIZE: obj.EKSIZE,
                            QSIZE: obj.QSIZE,  
                            QITEMSZ: obj.QITEMSZ,
                            CUFLAG: obj.CUFLAG,  
                            QLISTNC: obj.QLISTNC,
                            QITSEQ: obj.QITSEQ,  
                            QITTXT: obj.QITTXT,
                            use_description: obj.QITUSE,                                
                            quantity_per_car: obj.QITPCQ,   
                            years: obj.QIPYRS,   
                            QICSEQ: obj.QICSEQ,   
                            QIGSEQ: obj.QIGSEQ,   
                            QIGDSC: obj.QIGDSC,
                            image: (obj.EPIMG) ? obj.EPIMG : GCONST.THUMB_IMAGE_PLACEHOLDER,
                            QIMTAG: obj.QIMTAG,
                            QICON: obj.QICON,
                            catalog_part_number: obj.QICPN,
                            CLTYPE: obj.CLTYPE,
                            DEDESC: obj.DEDESC,
                            MCNAME: obj.MCNAME,
                            smartpage_url: obj.QITURL,
                            TOTOH: obj.TOTOH,
                            PARTN: obj.PARTN,
                            SHOWMTP: obj.SHOWMTP,
                            QITIMG: obj.QITIMG,
                            QITTMB: obj.QITTMB,
                            QTYPEC: obj.QTYPEC,
                            QMFRCD: obj.QMFRCD,
                            QITEMC: obj.QITEMC,
                            txt_list: this.parts_desc.filter(i => i.ETXITM == obj.QITEMNUM),

                            // partslink 
                            OE_number: (this.storeCatalog.toUpperCase() == 'PARTSLINK') ? obj.QICPN : '',
                            yr_range: (this.storeCatalog.toUpperCase() == 'PARTSLINK') ? obj.QIPYRS : '',
                        });
                    }

                    

                    this.partslen = response.data.webroutine.lists.PARTS.entries.length;
                    // console.log(this.parts);
                    const unique_desc = [...new Set(this.parts.map(item => item.description))];
                    unique_desc.forEach(u => {
                        this.unique_desc.push({
                            desc : u,
                            products: this.parts.filter(p => p.description == u)
                        });
                    });

                    this.$emit('total_items', this.partslen);
                }
                this.isloading = false;
            })
            .catch((error) => {
                console.log("error - " + error);
                this.isloading = false;
            });
        },

        searchPLGroup() {
            this.parts = [];
            this.isloading = true;
            let params;
            const pl_itemsearch_uri = this.$store.getters['api/pl_vh_grpsrc_uri'];
            const catpn = this.$store.getters['storeConfigID'];

            params = {
                "webroutine": {
                    "context": {
                        "session-key-method": "hidden"
                    },
                    "fields": {
                        "EHCUST": { "value": this.$store.getters.customer },
                        "CATPN": { "value": catpn },
                        "QYEAR": { "value": this.$store.getters['vehicle/selectedyear'] },
                        "QMKDSC": { "value": this.$store.getters['vehicle/selectedmake'].selectedmake },
                        "QMODSC": { "value": this.$store.getters['vehicle/selectedmodel'].selectedmodel },
                        "SRCGRP": {"value": this.keyword}
                    }
                }
            };

            axiosvl.post(pl_itemsearch_uri, params)
            .then((response) => {
                const fields = response.data.webroutine.fields;
                const lists = response.data.webroutine.lists;
                const ETXLIST = lists.ETXLIST.entries;
                // console.log(response.data.webroutine.lists.PARTS.entries);
                if (fields.RESULTCOD.value === 'OK') {

                    this.parts_desc = ETXLIST;

                    for (const key in response.data.webroutine.lists.PARTS.entries) {
                        const obj = response.data.webroutine.lists.PARTS.entries[key];
                        this.parts.push({
                            manufacturer: obj.QMFR,
                            manufacturerdesc: obj.QMFDSC,
                            sku: obj.QITEMNUM,
                            description: obj.QITDSC,
                            QLIST: obj.QLIST,
                            QCORE: obj.QCORE,
                            extended_price: obj.QSELL,
                            // stockquantity: obj.QOHAND,
                            stockquantity: (this.$store.getters.customerIndicator == 'B') ? obj.QOHAND : obj.TOTOH,
                            availability: obj.QOSTK,
                            list_price: obj.QLISTN,
                            core_charge: obj.QCOREN,
                            QTDESC: obj.QTDESC,
                            QSCORE: obj.QSCORE,
                            QSCOREN: obj.QSCOREN,
                            EKSIZE: obj.EKSIZE,
                            QSIZE: obj.QSIZE,  
                            QITEMSZ: obj.QITEMSZ,
                            CUFLAG: obj.CUFLAG,  
                            QLISTNC: obj.QLISTNC,
                            QITSEQ: obj.QITSEQ,  
                            QITTXT: obj.QITTXT,
                            use_description: obj.QITUSE,                                
                            quantity_per_car: obj.QITPCQ,   
                            years: obj.QIPYRS,   
                            QICSEQ: obj.QICSEQ,   
                            QIGSEQ: obj.QIGSEQ,   
                            QIGDSC: obj.QIGDSC,
                            image: (obj.EPIMG) ? obj.EPIMG : GCONST.THUMB_IMAGE_PLACEHOLDER,
                            QIMTAG: obj.QIMTAG,
                            QICON: obj.QICON,
                            catalog_part_number: obj.QICPN,
                            CLTYPE: obj.CLTYPE,
                            DEDESC: obj.DEDESC,
                            MCNAME: obj.MCNAME,
                            smartpage_url: obj.QITURL,
                            TOTOH: obj.TOTOH,
                            PARTN: obj.PARTN,
                            SHOWMTP: obj.SHOWMTP,
                            QITIMG: obj.QITIMG,
                            QITTMB: obj.QITTMB,
                            QTYPEC: obj.QTYPEC,
                            QMFRCD: obj.QMFRCD,
                            QITEMC: obj.QITEMC,
                            txt_list: this.parts_desc.filter(i => i.ETXITM == obj.QITEMNUM),

                            // partslink 
                            OE_number: (this.storeCatalog.toUpperCase() == 'PARTSLINK') ? obj.QICPN : '',
                            yr_range: (this.storeCatalog.toUpperCase() == 'PARTSLINK') ? obj.QIPYRS : '',
                        });
                    }
                    this.partslen = response.data.webroutine.lists.PARTS.entries.length;
                    // console.log(this.parts);
                    const unique_desc = [...new Set(this.parts.map(item => item.description))];
                    unique_desc.forEach(u => {
                        this.unique_desc.push({
                            desc : u,
                            products: this.parts.filter(p => p.description == u)
                        });
                    });

                    this.$emit('total_items', this.partslen);
                }
                this.isloading = false;
            })
            .catch((error) => {
                console.log("error - " + error);
                this.isloading = false;
            });
        },

        searchPLKeyword() {
            this.parts = [];
            this.isloading = true;
            let params;
            const pl_keysearch_uri = this.$store.getters['api/pl_keysearch_uri'];
            const catpn = this.$store.getters['storeConfigID'];

            params = {
                "webroutine": {
                    "context": {
                        "session-key-method": "hidden"
                    },
                    "fields": {
                        "EHCUST": { "value": this.$store.getters.customer },
                        "CATPN":    { "value": catpn },
                        "KEYWSRC": {"value": this.keyword}
                    }
                }
            };

            axiosvl.post(pl_keysearch_uri, params)
            .then((response) => {
                const fields = response.data.webroutine.fields;
                const lists = response.data.webroutine.lists;
                const ETXLIST = lists.ETXLIST.entries;
                // console.log(response.data.webroutine.lists.PARTS.entries);
                if (fields.RESULTCOD.value === 'OK') {

                    this.parts_desc = ETXLIST;

                    for (const key in response.data.webroutine.lists.PARTS.entries) {
                        const obj = response.data.webroutine.lists.PARTS.entries[key];
                        this.parts.push({
                            manufacturer: obj.QMFR,
                            manufacturerdesc: obj.QMFDSC,
                            sku: obj.QITEMNUM,
                            description: obj.QITDSC,
                            QLIST: obj.QLIST,
                            QCORE: obj.QCORE,
                            extended_price: obj.QSELL,
                            // stockquantity: obj.QOHAND,
                            stockquantity: (this.$store.getters.customerIndicator == 'B') ? obj.QOHAND : obj.TOTOH,
                            availability: obj.QOSTK,
                            list_price: obj.QLISTN,
                            core_charge: obj.QCOREN,
                            QTDESC: obj.QTDESC,
                            QSCORE: obj.QSCORE,
                            QSCOREN: obj.QSCOREN,
                            EKSIZE: obj.EKSIZE,
                            QSIZE: obj.QSIZE,  
                            QITEMSZ: obj.QITEMSZ,
                            CUFLAG: obj.CUFLAG,  
                            QLISTNC: obj.QLISTNC,
                            QITSEQ: obj.QITSEQ,  
                            QITTXT: obj.QITTXT,
                            use_description: obj.QITUSE,                                
                            quantity_per_car: obj.QITPCQ,   
                            years: obj.QIPYRS,   
                            QICSEQ: obj.QICSEQ,   
                            QIGSEQ: obj.QIGSEQ,   
                            QIGDSC: obj.QIGDSC,
                            image: (obj.EPIMG) ? obj.EPIMG : GCONST.THUMB_IMAGE_PLACEHOLDER,
                            QIMTAG: obj.QIMTAG,
                            QICON: obj.QICON,
                            catalog_part_number: obj.QICPN,
                            CLTYPE: obj.CLTYPE,
                            DEDESC: obj.DEDESC,
                            MCNAME: obj.MCNAME,
                            smartpage_url: obj.QITURL,
                            TOTOH: obj.TOTOH,
                            PARTN: obj.PARTN,
                            SHOWMTP: obj.SHOWMTP,
                            QITIMG: obj.QITIMG,
                            QITTMB: obj.QITTMB,
                            QTYPEC: obj.QTYPEC,
                            QMFRCD: obj.QMFRCD,
                            QITEMC: obj.QITEMC,
                            txt_list: this.parts_desc.filter(i => i.ETXITM == obj.QITEMNUM),

                            // partslink 
                            OE_number: (this.storeCatalog.toUpperCase() == 'PARTSLINK') ? obj.QICPN : '',
                            yr_range: (this.storeCatalog.toUpperCase() == 'PARTSLINK') ? obj.QIPYRS : '',
                        });
                    }
                    this.partslen = response.data.webroutine.lists.PARTS.entries.length;
                    // console.log(this.parts);
                    const unique_desc = [...new Set(this.parts.map(item => item.description))];
                    unique_desc.forEach(u => {
                        this.unique_desc.push({
                            desc : u,
                            products: this.parts.filter(p => p.description == u)
                        });
                    });

                    this.$emit('total_items', this.partslen);
                }
                this.isloading = false;
            })
            .catch((error) => {
                console.log("error - " + error);
                this.isloading = false;
            });
        },
    },

    created() {
        this.smartPageUrl = '';
        this.storeCatalog = this.$store.getters['storeCatalog'];
        this.has_alternative = this.storefrontAttributes.find(attribute => attribute.type === 'EAP').value;

        if(this.keyword != ''){
            switch (this.search_type){
                case "group":
                    this.searchPLGroup();
                    break
                case "item":
                    this.searchPLItems();
                    break
                case "keyword":
                    this.searchPLKeyword();
                    break
            }
            // 
        }else{
            this.searchParts();
        }
        
    },

    updated() {
        // console.log('vehicle selected updated');
        // this.searchParts();
        // this.selectedgroups = this.$store.getters['vehicle/selectedgroups'][0];
        // this.selectedcategories = this.$store.getters['vehicle/selectedcategories'][0];
    },
    renderTriggered(){
        // console.log('renderTriggered');
    }

}
</script>
    
<style>
    .smartDialog {
        height: 100% !important;
        width: 100% !important;
    }

    .smartDialog iframe {
        height: 100% !important;
        width: 100% !important;
    }

    dialog section.dialog-body{
        height: 94%;
    }

    .smartDialog .actions {
        display: none;
    }

</style>